import React from 'react';
import { Divider, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSessionTimelineTheme } from '../theme';

interface ExpandSectionProps {
  hiddenCount: number;
  onExpand: () => void;
}

export function ExpandSection({ hiddenCount, onExpand }: ExpandSectionProps) {
  const { getExpandSectionButtonSx } = useSessionTimelineTheme();

  return (
    <Divider component="div" variant="middle" textAlign="center" role="presentation" sx={{ py: 1 }}>
      <Button
        variant="text"
        size="small"
        onClick={onExpand}
        startIcon={<ExpandMoreIcon />}
        sx={getExpandSectionButtonSx()}
        aria-label={`${hiddenCount}개 더 보기`}
      >
        {hiddenCount}개 더 보기
      </Button>
    </Divider>
  );
}
